<template>
  <div class="home">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
      router>
      <el-menu-item index="/dashboard">대시보드</el-menu-item>
      <el-menu-item index="/management">관리</el-menu-item>
      <el-menu-item index="/memo">영업노트</el-menu-item>
      <el-menu-item index="/system">시스템</el-menu-item>
      <div class="right-menu">
        <el-button @click="$service.logout" size="small" type="danger" icon="el-icon-switch-button" circle></el-button>
      </div>
      <div class="right-menu">
        <el-popover
          placement="bottom"
          width="400"
          trigger="click"
          @show="showHistory">
          <el-table :data="history.list" :show-header="false" size="mini" v-loading="history.loading">
            <el-table-column width="40px">
              <template slot-scope="scope">
                <i v-if="scope.row.favorate" class="el-icon-star-on fav-btn fav-btn-on" @click="setFavorate(scope.row, false)"></i>
                <i v-else class="el-icon-star-off fav-btn fav-btn-off" @click="setFavorate(scope.row, true)"></i>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <router-link 
                  class="history-link"
                  :to="{name: 'management-detail', params: {company_pk: scope.row.pk}}">
                  {{scope.row.name}}
                </router-link>
              </template>
            </el-table-column>
            <el-table-column width="40px">
              <template slot-scope="scope">
                <i class="el-icon-close fav-btn" @click="removeFavorate(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <i slot="reference" class="el-icon-collection history-btn"></i>
          <!-- <el-button slot="reference" size="small" type="default" icon="el-icon-collection" circle></el-button> -->
        </el-popover>
      </div>
      <div class="right-menu">
        <el-input placeholder="고객 아이디 또는 회사이름 검색" 
          v-model="search.value" 
          size="small" 
          class="input-with-select"
          @keyup.enter.native="searchHander">
        </el-input>
      </div>
    </el-menu>
    <router-view :key="$route.name + ($route.params.company_pk || '')" />
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
    handleSelect (key) {
      this.activeIndex = key
    },
    searchHander () {
      if (!this.search.value) return;
      this.$router.push({name: 'management-onuse', query: {search: this.search.value}})
      this.search.value = ''
    },
    async showHistory () {
      this.history.loading = true
      let history = await this.$service.getHistory()
      this.history.list = history
      this.history.loading = false
    },
    async setFavorate (item, value) {
      item.favorate = value
      let history = await this.$service.addHistory(item)
      this.history.list = history
    },
    async removeFavorate (item) {
      let history = await this.$service.removeHistory(item)
      this.history.list = history
    }
  },
  data () {
    let activeIndex = this.$route.matched[1] ? this.$route.matched[1].path : ''
    return {
      activeIndex,
      search: {
        key: '',
        value: ''
      },
      history: {
        loading: false,
        list: []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .home {
    margin: 0; padding: 0;
    position: relative;
  }
  .right-menu {
    float: right;
    height: 60px;
    line-height: 60px;
    margin: 0;
    padding: 0 10px;
  }

  .fav-btn {
    cursor: pointer;
    &.fav-btn-on { color: orange }
    &.fav-btn-off { color: #cecece }
  }

  .history-btn {
    color: rgba(255, 255, 255, 0.6);
    font-size: 26px;
    vertical-align: middle;
    cursor: pointer;
    &:hover { color: white; }
  }

  .history-link {
    color: #888;
    text-decoration: none;
    &:hover {
      color: #000;
    }
  }
  
</style>

